import { ADDRESS_ENDPOINTS } from "./endpoints";
import type { AddressResponse } from "./types";
import { apiRequestWithData } from "../shared";
import { DEFAULT_API_OPTIONS } from "./constants";

export default async function getAddresses(): Promise<AddressResponse> {
  return apiRequestWithData<AddressResponse>(ADDRESS_ENDPOINTS.GET, DEFAULT_API_OPTIONS);
}
